<template>
    <div class="outDetail">
        <el-card shadow="never" class="box-card" style="margin-bottom: 8px;">
            <div class="affitem">
                <el-row>
                    <el-col :span="5">
                        <div class="headsrc"> <el-avatar :size="60" :src="dataInfo.headSrc"></el-avatar></div>
                    </el-col>
                    <el-col :span="15">
                        <div class="name">{{ dataInfo.name }}</div>
                        <div class="subdesc">{{ dataInfo.createTime }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="goods">
                            <img v-if="dataInfo.isStarMark == 0" src="@/assets/img/emil/kx.png"
                                @click.stop="starMark(item)">
                            <img v-if="dataInfo.isStarMark == 1" src="@/assets/img/emil/sx.png"
                                @click.stop="starMark(item)">
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>

        <el-card shadow="never" class="box-card">
            <div class="emailcontent">
                <div class="subtitle">{{ dataInfo.subject }}</div>
                <div v-html="dataInfo.dealEmailContentHtml"></div>
            </div>
        </el-card>
    </div>
</template>
<script>
import { QUERYEMAILSEND, EMAILSENDSTARMARK } from '@/api/emial'
export default {
    data() {
        return {
            dataInfo: {},
            id: null,
        }
    },
    created() {
        let id = this.$route.query.id
        this.id = id
        this.getData(id)
    },
    methods: {
        getData(id) {
            QUERYEMAILSEND({ id: id }).then(res => {
                this.dataInfo = res.data.body
            })
        },
        starMark() {
            EMAILSENDSTARMARK({ id: this.id }).then(res => {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.getData(this.id)
            })
        },
    }
}
</script>
<style lang="less" scoped>
.outDetail {
    height: 100%;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 8px 8px 8px 8px;
    background-color: #fff;

    /deep/.el-card__body {
        padding: 8px !important;
    }

    .affitem {
        height: 60px;

        .headsrc {
            height: 60px;
            line-height: 60px;
        }

        .name {
            height: 30px;
            line-height: 30px;
            font-weight: 600;
            font-size: 14px;
        }

        .subdesc {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
        }

        .goods {
            display: flex;
            height: 60px;
            flex-direction: row;
            flex-wrap: nowrap;
            text-align: center;
            justify-content: flex-end;
            align-items: center;

            img {
                width: 35px;
                height: 35px;
            }
        }
    }

    .emailcontent {
        .subtitle{
            line-height: 40px;
            font-weight: 600;
            font-size: 17px;
        }
    }
}
</style>